import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { Icon } from '@els/els-react--icon';

import AlertsList from '../AlertsList';

import './GroupItem.scss';

export default function GroupItem(props) {
  const { alertsIds } = props;

  return (
    <div className="alerts-cluster">
      <AlertsList alertsIds={alertsIds} />
      {alertsIds.size > 1 && (
        <div className="alerts-cluster-disclaimer">
          Any adjustments (Edit <Icon sprite="Edit" size="xs" isDecorative isVisible />) will be applied across the whole group.
        </div>
      )}
    </div>
  );
}

GroupItem.propTypes = {
  alertsIds: PropTypes.instanceOf(List).isRequired,
};
